/**
 * @file GlobalFooter/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

import {
    SUBSCRIPTION_CENTRE,
    SIGN_IN_PATH,
    FEATURES_PATH,
} from "../../constants/account";
import {
    CONSENT_MODAL_BUTTON_TEXT,
    CONSENT_MODAL_BUTTON_TYPE,
} from "../../utils/cmp/constants";
export const EXTERNAL_FOOTER_PATH = "meta/global/footer";

// Footer navigation
// Item Structure:
//   sectionName: list of all links belonging to navigation section 'sectionName'.  'sectionName' must be unique (e.g. 'contact')
//       link: the href for the link (required)
//       title: The text to show in the navigation. (required)
//       type: 'internal' or 'external' - indicates if this link is to something 'internal' or 'external' to the application itself (required)
//       search: 'returnto' - indicates that a search parameter "returnto" which is equal to the current URL should be added to the link. This is optional, but helpful for Account Centre links (optional)
export const FOOTER = {
    myaccount: [
        {
            link: SIGN_IN_PATH,
            title: "Profile",
            type: "internal",
        },
        {
            link: "https://gem.cbc.ca/benefits/",
            title: "CBC Gem",
            type: "external",
        },
        {
            link: SUBSCRIPTION_CENTRE,
            title: "Newsletters",
            type: "external",
        },
        {
            link: FEATURES_PATH,
            title: "About CBC Accounts",
            type: "internal",
        },
    ],
    connect: [
        {
            link: "https://www.facebook.com/cbc/",
            title: "Facebook",
            type: "external",
        },
        {
            link: "https://x.com/cbc/",
            title: "X",
            type: "external",
        },
        {
            link: "https://www.youtube.com/user/CBCtv",
            title: "YouTube",
            type: "external",
        },
        {
            link: "https://www.instagram.com/cbc/?hl=en",
            title: "Instagram",
            type: "external",
        },
        {
            link: "https://cbchelp.cbc.ca/hc/en-ca/categories/115000249853-Help-with-CBC-Apps",
            title: "Mobile",
            type: "external",
        },
        {
            link: "https://www.cbc.ca/rss/",
            title: "RSS",
            type: "external",
        },
        {
            link: "/radio/podcasts",
            title: "Podcasts",
            type: "internal",
        },
    ],
    contact: [
        {
            link: "https://cbchelp.cbc.ca/hc/en-ca/requests/new",
            title: "Submit Feedback",
            type: "external",
        },
        {
            link: "https://cbchelp.cbc.ca/hc/en-ca",
            title: "Help Centre",
            type: "external",
        },
    ],
    about: [
        {
            link: "https://cbc.radio-canada.ca/en",
            title: "Corporate Info",
            type: "external",
        },
        {
            link: "/sitemap",
            title: "Sitemap",
            type: "internal",
        },
        {
            link: "https://cbchelp.cbc.ca/hc/en-ca/sections/203864688-Using-or-licensing-CBC-content",
            title: "Reuse & Permission",
            type: "external",
        },
        {
            link: "https://cbc.radio-canada.ca/en/vision/governance/terms-of-use-digital-services",
            title: "Terms of Use",
            type: "external",
        },
        {
            link: "https://www.cbc.ca/account/privacy",
            title: "Privacy",
            type: "external",
        },
        {
            title: CONSENT_MODAL_BUTTON_TEXT,
            type: CONSENT_MODAL_BUTTON_TYPE,
            link: "/?displayPrivacyBanner",
        },
        {
            link: "https://cbc.radio-canada.ca/en/working-with-us/jobs/",
            title: "Jobs",
            type: "external",
        },
        {
            link: "https://cbc.radio-canada.ca/en/vision/unions-associations",
            title: "Our Unions",
            type: "external",
        },
        {
            link: "https://www.cbc.ca/independentproducers/",
            title: "Independent Producers",
            type: "external",
        },
        {
            link: "https://cbc.radio-canada.ca/en/impact-and-accountability/regulatory/political-ads-registry",
            title: "Political Ads Registry",
            type: "external",
        },
        {
            link: "https://youradchoices.ca",
            title: "AdChoices",
            type: "external",
        },
    ],
    services: [
        {
            link: "https://cbc.radio-canada.ca/en/ombudsman/",
            title: "Ombudsman",
            type: "external",
        },
        {
            link: "https://www.cbc.ca/news/corrections-clarifications-1.5893564",
            title: "Corrections and Clarifications",
            type: "external",
        },
        {
            link: "https://www.cbc.ca/news/public-appearances-1.4969965",
            title: "Public Appearances",
            type: "external",
        },
        {
            link: "https://cbc.radio-canada.ca/en/services/commercial-services/",
            title: "Commercial Services",
            type: "external",
        },
        {
            link: "https://www.cbcshop.ca/",
            title: "CBC Shop",
            type: "external",
        },
        {
            link: "https://cbc.radio-canada.ca/en/working-with-us/partners-and-suppliers/",
            title: "Doing Business with Us",
            type: "external",
        },
        {
            link: "https://www.cbc.ca/productionfacilities/",
            title: "Renting Facilities",
            type: "external",
        },
        {
            link: "https://ici.radio-canada.ca/rci/en",
            title: "Radio Canada International",
            type: "external",
        },
        {
            link: "https://www.cbc.ca/lite",
            title: "CBC Lite",
            type: "external",
        },
    ],
    accessibility: [
        {
            link: "/accessibility",
            title: "About CBC Accessibility",
            type: "internal",
        },
        {
            link: "/accessibility/accessibility-feedback-1.5131151",
            title: "Accessibility Feedback",
            type: "internal",
        },
    ],
};
